export default function authHeader() {
    let headers = {
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "Authorization": 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN0b3J5Ym9hcmRAbWFpbGluYXRvci5jb20iLCJwaG9uZW5vIjo' 
    }
    return headers; // for Spring Boot back-end    
}
